import { FC } from 'react';
import { Icon } from '../../../shared/ui';
import { QUICK_BUTTON_ITEMS } from '../config';
import { cn } from '@distribute/frontend/utils';

type Props = {
  item: (typeof QUICK_BUTTON_ITEMS)[number];
  onClick: () => void;
};

export const WorkspaceQuickButton: FC<Props> = ({ item, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="overflow-hidden text-nowrap group bg-base-white shadow-xs p-3 border border-gray-200 rounded-[10px] flex flex-nowrap gap-x-2 items-center justify-start text-md font-medium text-gray-700 hover:text-gray-800 hover:shadow-quick-button hover:bg-gray-50"
    >
      <span
        className={cn('w-7 h-7 rounded-md p-1 flex-shrink-0', item.className)}
      >
        <Icon glyph={item.glyph} width={20} />
      </span>

      <span>{item.label}</span>
    </button>
  );
};
